/**
 * Describes the type of parameter.
 * Either "tokenized" (by using regex to extract from input) or a manual type.
 */
const FormTemplateRuleParameterType = {
  TOKENIZER: 0,
  FORM_FIELD: 1,
  VALUE: 2,
  properties: {
    0: {
      rawValue: 'tokenizer',
    },
    1: {
      rawValue: 'form_field',
    },
    2: {
      rawValue: 'value',
    },
  },
}

if (Object.freeze) {
  Object.freeze(FormTemplateRuleParameterType)
}

export { FormTemplateRuleParameterType }
